module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"finished":"Tournament Finished! 🎉","willStart":"Tournament will start in","willEnd":"Tournament will end in"},"es":{"finished":"¡Torneo Finalizado! 🎉","willStart":"El torneo iniciará en","willEnd":"El torneo finalizará en"}}')
  delete Component.options._Ctor
}
